export class NewMessageForm {
  constructor(public vehicleId: number,
              public messageText: string) {
  }
}
